exports.IDS = {
  // IMG_URL: "http://192.168.16.38:4344",
  IMG_URL: "http://127.0.0.1:4344",
  // IMG_URL: "https://newrevenads-node.profcymabackend.com:4322",

  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
};
